import React from 'react';

export default function App({ children }) {
  return (
    <div className="home-app" style={{backgroundImage: `url(${require('../../images/background-fill.gif')})`}}>
      <div className="page-container">{children}</div>
    </div>
  );
}
